import React from 'react';
export function Footer() {
  return <footer className="w-full bg-transparent text-gray-400 py-8 border-t border-[#2A2A2A]" data-id="element-67">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-68">
        <div className="text-center space-y-4" data-id="element-69">
          <p className="text-gray-400" data-id="element-70">Material educativo profesional.</p>
          <div className="border-t border-[#2A2A2A] pt-6 mt-6" data-id="element-71">
            <p className="text-xs text-gray-500 mt-2" data-id="element-72">
              Este es material educativo de apoyo profesional. No reemplaza la
              formación académica ni la supervisión profesional. Diseñado para
              uso en contextos educativos formales en Argentina.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}